const routes = [
    {
        path: "/car/models",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: 'carmodel_index'
        }
    }
];

export default routes;
